import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import ConfirmEmailChangePage from '@/pages/confirm-email-change'

const searchSchema = z.object({
  token: z.string().min(20).max(200),
})

export const Route = createFileRoute('/confirm-email-change/')({
  validateSearch: (search) => searchSchema.parse(search),
  component: ConfirmEmailChangeRoute,
  staticData: { layout: 'public' },
})

function ConfirmEmailChangeRoute() {
  const { token } = Route.useSearch()
  return <ConfirmEmailChangePage token={token} />
}
